import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddFactorRes } from "./helper";

const addFactor = async (data: FactorReqT) =>
  axios.post(Routes.ADD_FACTOR, data);

export const useAddFactor = () =>
  useMutation({
    mutationKey: [Keys.ADD_FACTOR_MUT],
    mutationFn: addFactor,
    onSuccess: onAddFactorRes,
  });
